export const ACCOUNT_ID_PARAM_NAME = 'accountId';
export const ACCOUNT_ID_PARAM_TEMPLATE = `/:${ACCOUNT_ID_PARAM_NAME}?`;
